/* Reset et protection globale du widget */
#chatyx-widget-root,
#chatyx-widget-root *,
#chatyx-widget-root *:before,
#chatyx-widget-root *:after {
  font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
  text-decoration: none !important;
  list-style: none !important;
  vertical-align: baseline !important;
  background: transparent !important;
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
  text-align: inherit !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
  white-space: normal !important;
  direction: ltr !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

#chatyx-widget-root {
  --chatyx-primary: #7B40F1;
  --chatyx-primary-hover: #6635c8;
  --chatyx-secondary: #f9f9f9;
  --chatyx-border-color: #ddd;
  --chatyx-send-button: #7B40F1;
  --chatyx-send-button-hover: #6635c8;
  --chatyx-bubble-bg: #fff;
  --chatyx-message-bg: #fff;
  --chatyx-message-border: rgba(15, 23, 42, 0.08);
  --chatyx-safe-area-top: env(safe-area-inset-top, 0px);
  --chatyx-safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --chatyx-safe-area-left: env(safe-area-inset-left, 0px);
  --chatyx-safe-area-right: env(safe-area-inset-right, 0px);
  --chatyx-viewport-width: 100vw;
  --chatyx-viewport-height: 100vh;
  position: relative !important;
  z-index: 999999 !important;
}

#chatyx-widget-root.chat-open .chat-bubble {
  opacity: 0 !important;
  pointer-events: none !important;
  transform: scale(0.8) !important;
}

#chatyx-widget-root .chat-bubble {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  width: 60px !important;
  height: 60px !important;
  border-radius: 50% !important;
  background: var(--chatyx-bubble-bg) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.2) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  z-index: 999998 !important;
  transition: all 0.3s cubic-bezier(0.45, 1.5, 0.55, 0.98) !important;
  overflow: visible !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  appearance: none !important;
}

#chatyx-widget-root .chat-bubble:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25) !important;
}

#chatyx-widget-root .chat-bubble.active {
  animation: chatyx-pop 0.25s ease !important;
}

@keyframes chatyx-pop {
  0% { transform: scale(1) !important; }
  50% { transform: scale(0.9) !important; }
  100% { transform: scale(1) !important; }
}

#chatyx-widget-root .chat-bubble img {
  width: 90% !important;
  height: 90% !important;
  object-fit: contain !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border-radius: 50% !important;
}

#chatyx-widget-root .chatyx-unread-badge {
  position: absolute !important;
  top: -6px !important;
  right: -6px !important;
  min-width: 22px !important;
  height: 22px !important;
  border-radius: 11px !important;
  background: #ef4444 !important;
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  line-height: 22px !important;
  text-align: center !important;
  padding: 0 6px !important;
  display: none !important;
  pointer-events: none !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.5) !important;
  z-index: 999999 !important;
  border: 2px solid #fff !important;
}

#chatyx-widget-root .chatyx-unread-badge.visible {
  display: block !important;
  animation: chatyx-badge-pulse 1.5s ease-in-out infinite !important;
}

@keyframes chatyx-badge-pulse {
  0%, 100% { transform: scale(1) !important; box-shadow: 0 2px 8px rgba(239, 68, 68, 0.5) !important; }
  50% { transform: scale(1.15) !important; box-shadow: 0 2px 12px rgba(239, 68, 68, 0.7) !important; }
}

#chatyx-widget-root .chat-container {
  position: fixed !important;
  bottom: 90px !important;
  right: 20px !important;
  width: min(380px, calc(var(--chatyx-viewport-width) - 40px)) !important;
  height: min(600px, calc(var(--chatyx-viewport-height) - 110px - var(--chatyx-safe-area-top) - var(--chatyx-safe-area-bottom))) !important;
  background: #fff !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 20px !important;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden !important;
  z-index: 999999 !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 0 !important;
  transform: translateY(14px) scale(0.96) !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transition: opacity 0.32s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.32s cubic-bezier(0.16, 1, 0.3, 1),
              visibility 0s linear 0.32s !important;
}

#chatyx-widget-root .chat-container.show {
  opacity: 1 !important;
  transform: translateY(0) scale(1) !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transition: opacity 0.32s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.32s cubic-bezier(0.16, 1, 0.3, 1),
              visibility 0s linear 0s !important;
}

/* Embedded / preview mode: the widget fills its host container (e.g. an
   iframe in the dashboard) instead of floating. The launcher bubble and the
   close button are hidden, and the chat window is always shown. */
#chatyx-widget-root.chatyx-embedded {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

#chatyx-widget-root.chatyx-embedded .chat-bubble,
#chatyx-widget-root.chatyx-embedded .chat-close-button {
  display: none !important;
}

#chatyx-widget-root.chatyx-embedded .chat-container {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  opacity: 1 !important;
  transform: none !important;
  visibility: visible !important;
  pointer-events: auto !important;
}

#chatyx-widget-root a {
  color: var(--chatyx-primary) !important;
  text-decoration: underline !important;
  text-decoration-thickness: 0.12em !important;
  text-underline-offset: 3px !important;
  font-weight: 700 !important;
  transition: color 0.2s ease, text-decoration-color 0.2s ease !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
}

#chatyx-widget-root a:hover,
#chatyx-widget-root a:focus-visible {
  color: var(--chatyx-primary-hover) !important;
  text-decoration-color: var(--chatyx-primary-hover) !important;
}

#chatyx-widget-root .message-row .bubble li a {
  display: inline !important;
  word-break: break-all !important;
  overflow-wrap: anywhere !important;
  hyphens: auto !important;
  line-height: 1.4 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 2px !important;
  font-weight: 600 !important;
}

#chatyx-widget-root .chat-header-custom {
  background: var(--chatyx-primary) !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
  padding: 16px 18px 10px 14px !important;
  padding-top: calc(16px + var(--chatyx-safe-area-top)) !important;
  position: relative !important;
  flex-direction: row !important;
  border: none !important;
  margin: 0 !important;
  min-height: auto !important;
  max-height: none !important;
}

#chatyx-widget-root .header-bot-avatar {
  width: 45px !important;
  height: 45px !important;
  min-width: 45px !important;
  border-radius: 50% !important;
  background: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 3px solid rgba(51, 220, 157, 0.3) !important;
  box-sizing: border-box !important;
  position: relative !important;
  top: -2px !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
}

#chatyx-widget-root .header-bot-avatar img {
  width: 73% !important;
  height: 73% !important;
  object-fit: contain !important;
  border-radius: 50% !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

#chatyx-widget-root .header-info-wrap {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  flex: 1 !important;
  /* Reserve room on the right for the absolutely-positioned header buttons so a
     long bot name never slides underneath them (3 buttons ≈ 88px wide). */
  margin: 0 calc(90px + var(--chatyx-safe-area-right)) 0 0 !important;
  padding: 0 !important;
  min-width: 0 !important;
}

#chatyx-widget-root .chatbot-title {
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  margin: 0 0 3px 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  text-align: left !important;
  background: transparent !important;
  /* Truncate overly long names with an ellipsis instead of overflowing. */
  display: block !important;
  max-width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

#chatyx-widget-root .bot-status {
  font-size: 13px !important;
  color: #DBF4E2 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  text-align: left !important;
  background: transparent !important;
}

#chatyx-widget-root .bot-status-online {
  width: 9px !important;
  height: 9px !important;
  border-radius: 50% !important;
  background: #46DF9E !important;
  display: inline-block !important;
  box-shadow: 0 0 0 2px rgba(29, 186, 113, 0.3) !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  flex-shrink: 0 !important;
}

#chatyx-widget-root .chat-header-buttons {
  position: absolute !important;
  top: calc(12px + var(--chatyx-safe-area-top)) !important;
  right: calc(14px + var(--chatyx-safe-area-right)) !important;
  display: flex !important;
  gap: 8px !important;
  margin: 0 !important;
  padding: 0 !important;
}

#chatyx-widget-root .chat-header-button {
  width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: white !important;
  border: 1.5px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  z-index: 100 !important;
  transition: all 0.2s ease-in-out !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
  position: relative !important;
  flex-shrink: 0 !important;
  appearance: none !important;
}

#chatyx-widget-root .chat-bubble:focus-visible,
#chatyx-widget-root .chat-header-button:focus-visible,
#chatyx-widget-root .message-input button:focus-visible,
#chatyx-widget-root .message-input input:focus-visible {
  outline: 2px solid #111827 !important;
  outline-offset: 2px !important;
}

#chatyx-widget-root .chat-header-button:hover {
  transform: scale(1.1) !important;
  border-color: rgba(0, 0, 0, 0.6) !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15) !important;
}

#chatyx-widget-root .chat-close-button:hover {
  transform: scale(1.1) rotate(90deg) !important;
}

#chatyx-widget-root .chat-close-button:before,
#chatyx-widget-root .chat-close-button:after {
  content: '' !important;
  position: absolute !important;
  width: 14px !important;
  height: 2px !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  transition: background-color 0.2s !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

#chatyx-widget-root .chat-close-button:hover:before,
#chatyx-widget-root .chat-close-button:hover:after {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

#chatyx-widget-root .chat-close-button:before {
  transform: rotate(45deg) !important;
}

#chatyx-widget-root .chat-close-button:after {
  transform: rotate(-45deg) !important;
}

/* Icons inside the round header buttons (theme / refresh). */
#chatyx-widget-root .chat-header-button svg {
  width: 13px !important;
  height: 13px !important;
  display: block !important;
  color: rgba(0, 0, 0, 0.7) !important;
  transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1), color 0.2s ease !important;
}

#chatyx-widget-root .chat-header-button:hover svg {
  color: rgba(0, 0, 0, 0.95) !important;
}

/* Refresh button: full spin on hover, echoing the close button's rotate. */
#chatyx-widget-root .chat-refresh-button:hover svg {
  transform: rotate(-360deg) !important;
}

/* Theme toggle: a soft pivot keeps the sun/moon swap lively but minimal. */
#chatyx-widget-root .chat-theme-button:hover svg {
  transform: rotate(20deg) !important;
}

/* Left-aligned ghost button that opens the conversations list. Sits on the
   coloured header, so it uses a white icon with a subtle hover wash. */
#chatyx-widget-root .chat-header-nav {
  width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: center !important;
  background: transparent !important;
  border: none !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  margin: 0 -2px 0 0 !important;
  padding: 0 !important;
  appearance: none !important;
  transition: background-color 0.2s ease, transform 0.2s ease !important;
}

#chatyx-widget-root .chat-header-nav svg {
  width: 18px !important;
  height: 18px !important;
  display: block !important;
  color: rgba(255, 255, 255, 0.92) !important;
  transition: transform 0.2s ease !important;
}

#chatyx-widget-root .chat-header-nav:hover {
  background: rgba(255, 255, 255, 0.18) !important;
}

/* Slide the arrow left on hover to reinforce the "back" affordance. */
#chatyx-widget-root .chat-header-nav:hover svg {
  transform: translateX(-2px) !important;
}

#chatyx-widget-root .chat-header-nav:active {
  transform: scale(0.92) !important;
}

#chatyx-widget-root .chat-header-nav:focus-visible {
  outline: 2px solid #fff !important;
  outline-offset: 2px !important;
}

#chatyx-widget-root .chat-messages {
  flex: 1 !important;
  overflow-y: auto !important;
  background: var(--chatyx-secondary) !important;
  padding: 12px !important;
  margin: 0 !important;
  border: none !important;
  position: relative !important;
  max-height: none !important;
  min-height: 0 !important;
}

#chatyx-widget-root .chat-messages::-webkit-scrollbar {
  width: 4px !important;
}

#chatyx-widget-root .chat-messages::-webkit-scrollbar-track {
  background: transparent !important;
}

#chatyx-widget-root .chat-messages::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2) !important;
  border-radius: 2px !important;
}

#chatyx-widget-root .message-row {
  display: flex !important;
  gap: 8px !important;
  margin: 0 0 12px 0 !important;
  padding: 0 !important;
  align-items: flex-start !important;
  border: none !important;
  background: transparent !important;
  width: 100% !important;
}

#chatyx-widget-root .message-row.bot {
  justify-content: flex-start !important;
  flex-direction: row !important;
}

#chatyx-widget-root .message-row.user {
  justify-content: flex-end !important;
  flex-direction: row !important;
}

#chatyx-widget-root .message-row .avatar {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  flex-shrink: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  overflow: hidden !important;
  order: 1 !important;
}

#chatyx-widget-root .message-row.user .avatar {
  order: 2 !important;
  margin-left: 8px !important;
  margin-right: 0 !important;
}

#chatyx-widget-root .message-row.bot .avatar {
  order: 1 !important;
  margin-left: 0 !important;
  margin-right: 8px !important;
}

#chatyx-widget-root .message-row .avatar img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

#chatyx-widget-root .message-row .bubble {
  max-width: 75% !important;
  padding: 10px 12px !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  margin: 0 !important;
  border: none !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: manual !important;
  text-align: left !important;
  position: relative !important;
}

#chatyx-widget-root .message-row.user .bubble {
  background: var(--chatyx-message-bg) !important;
  border: 1px solid var(--chatyx-message-border) !important;
  border-radius: 12px 12px 5px 12px !important;
  color: #333 !important;
  order: 1 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

#chatyx-widget-root .message-row.bot .bubble {
  background: var(--chatyx-message-bg) !important;
  border: 1px solid var(--chatyx-message-border) !important;
  border-radius: 12px 12px 12px 5px !important;
  color: #333 !important;
  order: 2 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

#chatyx-widget-root .message-row .bubble a {
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
}

#chatyx-widget-root .message-meta {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  font-size: 11px !important;
  color: #888 !important;
  margin: -8px 0 10px 0 !important;
  padding: 0 40px !important;
  line-height: 1 !important;
}

#chatyx-widget-root .message-meta-user {
  justify-content: flex-end !important;
}

#chatyx-widget-root .message-meta-bot {
  justify-content: flex-start !important;
}

#chatyx-widget-root .message-meta .message-time {
  font-size: 11px !important;
  color: #888 !important;
  font-weight: 400 !important;
}

#chatyx-widget-root .message-meta .message-check {
  display: inline-flex !important;
  align-items: center !important;
  color: #888 !important;
  transition: color 0.2s ease !important;
}

#chatyx-widget-root .message-meta .message-check svg {
  width: 14px !important;
  height: 14px !important;
  display: block !important;
}

#chatyx-widget-root .message-meta .message-check.seen {
  color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .message-row .bubble ul,
#chatyx-widget-root .message-row .bubble ol {
  margin: 8px 0 8px 0 !important;
  padding-left: 1.4em !important;
  list-style-position: outside !important;
  color: inherit !important;
}

#chatyx-widget-root .message-row .bubble ul {
  list-style-type: disc !important;
}

#chatyx-widget-root .message-row .bubble ol {
  list-style-type: decimal !important;
}

#chatyx-widget-root .message-row .bubble li {
  margin: 4px 0 !important;
  line-height: 1.5 !important;
  padding-left: 0 !important;
  display: list-item !important;
  list-style-position: outside !important;
  color: inherit !important;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
}

#chatyx-widget-root .message-row .bubble ul > li {
  list-style-type: disc !important;
}

#chatyx-widget-root .message-row .bubble ol > li {
  list-style-type: decimal !important;
}

#chatyx-widget-root .message-row .bubble ul ul > li {
  list-style-type: circle !important;
}

#chatyx-widget-root .message-row .bubble ul ul ul > li {
  list-style-type: square !important;
}

#chatyx-widget-root .message-row .bubble li::marker {
  color: var(--chatyx-primary) !important;
  font-size: 0.95em !important;
}

#chatyx-widget-root .message-row .bubble li > ul,
#chatyx-widget-root .message-row .bubble li > ol {
  margin-top: 4px !important;
}

#chatyx-widget-root .chat-suggestions {
  margin: 6px 0 12px 42px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  width: calc(100% - 42px) !important;
}

#chatyx-widget-root .chat-suggestions button {
  background: #F2F5F8 !important;
  color: #444 !important;
  border: 1px solid #eee !important;
  border-radius: 20px !important;
  cursor: pointer !important;
  padding: 8px 15px !important;
  font-size: 13px !important;
  transition: all 0.18s ease !important;
  margin: 0 !important;
  font-family: 'Nunito', sans-serif !important;
  outline: none !important;
  text-align: left !important;
  white-space: normal !important;
  width: 100% !important;
  display: block !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
  hyphens: manual !important;
  line-height: 1.45 !important;
}

#chatyx-widget-root .chat-suggestions button:hover {
  background: var(--chatyx-primary) !important;
  color: #fff !important;
  border-color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .message-input {
  padding: 12px !important;
  padding-bottom: 6px !important;
  display: flex !important;
  gap: 8px !important;
  background: #fff !important;
  border-top: 1px solid #eee !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
  margin: 0 !important;
  align-items: center !important;
  position: relative !important;
}

#chatyx-widget-root .message-input input {
  flex: 1 !important;
  padding: 10px 16px !important;
  border: 2px solid var(--chatyx-border-color) !important;
  border-radius: 20px !important;
  font-size: 13px !important;
  transition: all 0.3s ease !important;
  background: #fff !important;
  color: #333 !important;
  margin: 0 !important;
  font-family: 'Nunito', sans-serif !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

#chatyx-widget-root .message-input input:focus {
  border-color: var(--chatyx-primary) !important;
  box-shadow: 0 0 8px rgba(139, 92, 246, 0.4) !important;
  outline: none !important;
}

#chatyx-widget-root .message-input input:disabled {
  background: #f5f5f5 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

#chatyx-widget-root .message-input input::placeholder {
  color: #999 !important;
  opacity: 1 !important;
}

#chatyx-widget-root .message-input button {
  background: var(--chatyx-send-button) !important;
  border: none !important;
  width: 42px !important;
  height: 42px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  margin: 0 !important;
  outline: none !important;
  position: relative !important;
}

#chatyx-widget-root .message-input button:disabled {
  background: #ccc !important;
  cursor: not-allowed !important;
  transform: none !important;
  opacity: 0.6 !important;
}

#chatyx-widget-root .message-input button:hover:not(:disabled) {
  background: var(--chatyx-send-button-hover) !important;
  transform: scale(1.12) rotate(-6deg) !important;
}

#chatyx-widget-root .message-input button img {
  width: 75% !important;
  height: 75% !important;
  object-fit: contain !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

#chatyx-widget-root .ai-disclaimer {
  text-align: center !important;
  font-size: 10px !important;
  color: #999 !important;
  background: #fff !important;
  padding: 0 12px !important;
  padding-bottom: calc(8px + var(--chatyx-safe-area-bottom)) !important;
  margin: 0 !important;
  border: none !important;
  line-height: 1.3 !important;
}

#chatyx-widget-root .branding {
  text-align: center !important;
  font-size: 11px !important;
  color: #999 !important;
  background: #f9f9f9 !important;
  padding: 4px !important;
  padding-bottom: calc(4px + var(--chatyx-safe-area-bottom)) !important;
  margin: 0 !important;
  border: none !important;
  line-height: 1.2 !important;
}

#chatyx-widget-root .branding.hidden {
  display: none !important;
}

#chatyx-widget-root .branding strong {
  font-weight: 600 !important;
  color: #666 !important;
}

#chatyx-widget-root .consent-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(255, 255, 255, 0.98) !important;
  display: none !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 30px !important;
  z-index: 1000 !important;
  border-radius: 20px !important;
  margin: 0 !important;
  border: none !important;
}

#chatyx-widget-root .consent-overlay.show {
  display: flex !important;
}

#chatyx-widget-root .consent-content {
  text-align: center !important;
  max-width: 320px !important;
  margin: 0 !important;
  padding: 0 !important;
}

#chatyx-widget-root .consent-title {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #333 !important;
  margin: 0 0 15px 0 !important;
  padding: 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

#chatyx-widget-root .consent-text {
  font-size: 13px !important;
  color: #666 !important;
  line-height: 1.5 !important;
  margin: 0 0 20px 0 !important;
  padding: 0 !important;
  text-align: center !important;
}

#chatyx-widget-root .consent-text a {
  color: var(--chatyx-primary) !important;
  text-decoration: none !important;
  font-weight: 500 !important;
}

#chatyx-widget-root .consent-text a:hover {
  text-decoration: underline !important;
}

#chatyx-widget-root .consent-checkbox-container {
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
  margin: 0 0 20px 0 !important;
  text-align: left !important;
  padding: 0 !important;
}

#chatyx-widget-root .consent-checkbox {
  margin: 2px 0 0 0 !important;
  padding: 0 !important;
  width: auto !important;
  height: auto !important;
  flex-shrink: 0 !important;
  accent-color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .consent-checkbox-label {
  font-size: 12px !important;
  color: #555 !important;
  line-height: 1.4 !important;
  margin: 0 !important;
  padding: 0 !important;
  cursor: pointer !important;
  text-align: left !important;
}

#chatyx-widget-root .consent-buttons {
  display: flex !important;
  gap: 10px !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 !important;
}

#chatyx-widget-root .consent-button {
  padding: 10px 20px !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  margin: 0 !important;
  font-family: 'Nunito', sans-serif !important;
  outline: none !important;
  text-align: center !important;
}

#chatyx-widget-root .consent-accept {
  background: var(--chatyx-primary) !important;
  color: white !important;
}

#chatyx-widget-root .consent-accept:hover:not(:disabled) {
  background: var(--chatyx-primary-hover) !important;
}

#chatyx-widget-root .consent-accept:disabled {
  background: #ccc !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

#chatyx-widget-root .consent-decline {
  background: #f5f5f5 !important;
  color: #666 !important;
  border: 1px solid #ddd !important;
}

#chatyx-widget-root .consent-decline:hover {
  background: #e5e5e5 !important;
}

#chatyx-widget-root .chat-toast {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  background: #333 !important;
  color: white !important;
  padding: 12px 20px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  z-index: 1000000 !important;
  animation: chatyx-slideIn 0.3s ease-out !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;
}

@keyframes chatyx-slideIn {
  from {
    transform: translateX(100%) !important;
    opacity: 0 !important;
  }
  to {
    transform: translateX(0) !important;
    opacity: 1 !important;
  }
}

#chatyx-widget-root .message-row.bot .bubble.typing-bubble,
#chatyx-widget-root .message-row.user .bubble.typing-bubble {
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.9), rgba(244, 244, 255, 0.95)) !important;
  border: 1px solid rgba(123, 64, 241, 0.1) !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06) !important;
  backdrop-filter: blur(2px) !important;
  border-radius: 14px 14px 14px 6px !important;
  padding: 10px 12px !important;
  display: inline-flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 8px !important;
  min-width: 220px !important;
}

#chatyx-widget-root .typing-shimmer {
  display: block !important;
  width: 100% !important;
}

#chatyx-widget-root .typing-shimmer-content {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  gap: 6px !important;
}

#chatyx-widget-root .typing-shimmer-line {
  display: block !important;
  width: 100% !important;
  height: 10px !important;
  border-radius: 999px !important;
  background: #e2e8f0 !important;
  position: relative !important;
  overflow: hidden !important;
}

#chatyx-widget-root .typing-shimmer-line-sub {
  width: 52% !important;
}

#chatyx-widget-root .typing-shimmer-line::after {
  content: '' !important;
  position: absolute !important;
  inset: 0 !important;
  transform: translateX(-100%);
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.34) 35%,
    rgba(255, 255, 255, 0.68) 50%,
    rgba(255, 255, 255, 0.34) 65%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
  animation: chatyx-skeleton-shimmer 2.25s ease-in-out infinite !important;
}

#chatyx-widget-root .typing-label {
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0.01em !important;
  color: #64748b !important;
  display: block !important;
  margin-bottom: 8px !important;
}

#chatyx-widget-root .typing-label-shimmer {
  color: transparent !important;
  background-image: linear-gradient(
    110deg,
    #64748b 15%,
    #7b40f1 48%,
    #a78bfa 55%,
    #64748b 85%
  ) !important;
  background-size: 230% 100% !important;
  background-position: 120% 0;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  animation: chatyx-label-shimmer 2.6s linear infinite !important;
}

#chatyx-widget-root.theme-dark .typing-label {
  color: #cbd5e1 !important;
}

#chatyx-widget-root.theme-dark .typing-label-shimmer {
  background-image: linear-gradient(
    110deg,
    #cbd5e1 15%,
    #c4b5fd 50%,
    #e9d5ff 58%,
    #cbd5e1 85%
  ) !important;
}

#chatyx-widget-root.theme-dark .typing-shimmer-line {
  background: rgba(148, 163, 184, 0.26) !important;
}

#chatyx-widget-root.theme-dark .typing-shimmer-line::after {
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(196, 181, 253, 0.12) 35%,
    rgba(196, 181, 253, 0.32) 50%,
    rgba(196, 181, 253, 0.12) 65%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
}

@keyframes chatyx-skeleton-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(120%);
  }
}

@keyframes chatyx-label-shimmer {
  0% {
    background-position: 120% 0;
  }
  100% {
    background-position: -120% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  #chatyx-widget-root .typing-shimmer-line::after {
    animation-duration: 6s !important;
  }

  #chatyx-widget-root .typing-label-shimmer {
    animation-duration: 8s !important;
  }
}

#chatyx-widget-root .streaming-cursor {
  display: inline-block !important;
  width: 3px !important;
  height: 1em !important;
  margin-left: 2px !important;
  vertical-align: text-bottom !important;
  background-color: var(--chatyx-primary) !important;
  border-radius: 1px !important;
  opacity: 0.9 !important;
  animation: chatyx-cursor-blink 1s steps(2, start) infinite !important;
}

@keyframes chatyx-cursor-blink {
  to { visibility: hidden; }
}

@keyframes chatyx-fadeIn {
  0% {
    opacity: 0 !important;
    transform: translateY(18px) scale(0.96) !important;
  }
  60% {
    opacity: 1 !important;
    transform: translateY(0) scale(1.01) !important;
  }
  100% {
    opacity: 1 !important;
    transform: translateY(0) scale(1) !important;
  }
}

#chatyx-widget-root .message-fade-in {
  animation: chatyx-fadeIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
}

/* ============================================================ */
/* CARROUSEL DE PRODUITS */
/* ============================================================ */

#chatyx-widget-root .product-carousel-container {
  margin: 12px 0 !important;
  padding: 0 !important;
  background: transparent !important;
  width: 100% !important;
}

#chatyx-widget-root .product-carousel {
  position: relative !important;
  background: #fff !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
}

#chatyx-widget-root .product-carousel-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 14px !important;
  background: linear-gradient(135deg, var(--chatyx-primary) 0%, var(--chatyx-primary-hover) 100%) !important;
  color: white !important;
  border: none !important;
  margin: 0 !important;
}

#chatyx-widget-root .product-carousel-title {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: white !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

#chatyx-widget-root .product-carousel-count {
  font-size: 11px !important;
  background: rgba(255, 255, 255, 0.25) !important;
  padding: 3px 8px !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  color: white !important;
  margin: 0 !important;
  border: none !important;
}

#chatyx-widget-root .product-carousel-track-container {
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
  border: none !important;
}

#chatyx-widget-root .product-carousel-track {
  display: flex !important;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

#chatyx-widget-root .product-carousel-slide {
  min-width: 100% !important;
  padding: 16px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
}

#chatyx-widget-root .product-image-container {
  position: relative !important;
  width: 100% !important;
  padding-top: 75% !important;
  background: #f8f9fa !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  margin: 0 !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

#chatyx-widget-root .product-image {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  padding: 8px !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
}

#chatyx-widget-root .product-image-placeholder {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  font-size: 48px !important;
  opacity: 0.3 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

#chatyx-widget-root .product-info {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

#chatyx-widget-root .product-name {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #1a1a1a !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.3 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-break: break-word !important;
}

#chatyx-widget-root .product-price {
  font-size: 18px !important;
  font-weight: 800 !important;
  color: var(--chatyx-primary) !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}

#chatyx-widget-root .product-description {
  font-size: 13px !important;
  color: #666 !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

#chatyx-widget-root .product-link {
  display: inline-block !important;
  background: var(--chatyx-primary) !important;
  color: white !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  text-decoration: none !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  text-align: center !important;
  transition: all 0.2s ease !important;
  margin: 4px 0 0 0 !important;
  border: none !important;
  cursor: pointer !important;
}

#chatyx-widget-root .product-link:hover {
  background: var(--chatyx-primary-hover) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  color: white !important;
  text-decoration: none !important;
}

#chatyx-widget-root .carousel-nav {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 36px !important;
  height: 36px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  z-index: 10 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #333 !important;
  user-select: none !important;
}

#chatyx-widget-root .carousel-nav:hover {
  background: white !important;
  transform: translateY(-50%) scale(1.1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

#chatyx-widget-root .carousel-nav:active {
  transform: translateY(-50%) scale(0.95) !important;
}

#chatyx-widget-root .carousel-nav.disabled,
#chatyx-widget-root .carousel-nav[disabled] {
  opacity: 0.3 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

#chatyx-widget-root .carousel-nav:focus-visible,
#chatyx-widget-root .carousel-indicator:focus-visible,
#chatyx-widget-root .product-carousel:focus-visible {
  outline: 2px solid var(--chatyx-primary) !important;
  outline-offset: 2px !important;
}

#chatyx-widget-root .carousel-nav-prev {
  left: 8px !important;
}

#chatyx-widget-root .carousel-nav-next {
  right: 8px !important;
}

#chatyx-widget-root .carousel-indicators {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 12px !important;
  margin: 0 !important;
  background: #fff !important;
  border: none !important;
  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
}

#chatyx-widget-root .carousel-indicator {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background: #ddd !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

#chatyx-widget-root .carousel-indicator.active {
  background: var(--chatyx-primary) !important;
  width: 24px !important;
  border-radius: 4px !important;
}

#chatyx-widget-root .carousel-indicator:hover {
  background: var(--chatyx-primary-hover) !important;
}

#chatyx-widget-root .product-badge {
  display: inline-block !important;
  background: #e8f5e9 !important;
  color: #2e7d32 !important;
  padding: 4px 10px !important;
  border-radius: 4px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  border: none !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

#chatyx-widget-root .product-badge.out-of-stock {
  background: #ffebee !important;
  color: #c62828 !important;
}

/* ============================================================ */
/* CONVERSATIONS LIST ("PAGE") + NEW-CONVERSATION MODAL          */
/* ============================================================ */

#chatyx-widget-root .chatyx-conversations-panel {
  position: absolute !important;
  inset: 0 !important;
  background: var(--chatyx-secondary) !important;
  display: flex !important;
  flex-direction: column !important;
  z-index: 1100 !important;
  border-radius: 20px !important;
  margin: 0 !important;
  border: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transform: translateX(8%) !important;
  transition: opacity 0.28s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.28s cubic-bezier(0.16, 1, 0.3, 1),
              visibility 0s linear 0.28s !important;
}

#chatyx-widget-root .chatyx-conversations-panel.show {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transform: translateX(0) !important;
  transition: opacity 0.28s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.28s cubic-bezier(0.16, 1, 0.3, 1),
              visibility 0s linear 0s !important;
}

#chatyx-widget-root .chatyx-conversations-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 18px 18px 14px 18px !important;
  padding-top: calc(18px + var(--chatyx-safe-area-top)) !important;
  background: #fff !important;
  border-bottom: 1px solid rgba(15, 23, 42, 0.07) !important;
  flex-shrink: 0 !important;
}

#chatyx-widget-root .chatyx-conversations-title {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #1a1a1a !important;
  line-height: 1.2 !important;
}

#chatyx-widget-root .chatyx-conversations-list {
  flex: 1 !important;
  overflow-y: auto !important;
  padding: 8px !important;
  margin: 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
}

#chatyx-widget-root .chatyx-conversations-list::-webkit-scrollbar {
  width: 4px !important;
}

#chatyx-widget-root .chatyx-conversations-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 2px !important;
}

#chatyx-widget-root .chatyx-conversation-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  width: 100% !important;
  text-align: left !important;
  background: transparent !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 12px 12px !important;
  margin: 0 !important;
  cursor: pointer !important;
  appearance: none !important;
  font-family: 'Nunito', sans-serif !important;
  transition: background-color 0.18s ease, transform 0.18s ease !important;
}

#chatyx-widget-root .chatyx-conversation-item:hover {
  background: rgba(15, 23, 42, 0.05) !important;
}

#chatyx-widget-root .chatyx-conversation-item:active {
  transform: scale(0.99) !important;
}

#chatyx-widget-root .chatyx-conversation-item.active {
  background: rgba(123, 64, 241, 0.1) !important;
  background: color-mix(in srgb, var(--chatyx-primary) 12%, transparent) !important;
}

#chatyx-widget-root .chatyx-conversation-item:focus-visible {
  outline: 2px solid var(--chatyx-primary) !important;
  outline-offset: 2px !important;
}

#chatyx-widget-root .chatyx-conversation-avatar {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border-radius: 50% !important;
  background: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
}

#chatyx-widget-root .chatyx-conversation-avatar img {
  width: 72% !important;
  height: 72% !important;
  object-fit: contain !important;
}

#chatyx-widget-root .chatyx-conversation-body {
  flex: 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
}

#chatyx-widget-root .chatyx-conversation-preview {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #1f2937 !important;
  line-height: 1.3 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

#chatyx-widget-root .chatyx-conversation-time {
  font-size: 12px !important;
  color: #94a3b8 !important;
  line-height: 1.2 !important;
}

#chatyx-widget-root .chatyx-conversation-chevron {
  display: flex !important;
  align-items: center !important;
  color: #cbd5e1 !important;
  flex-shrink: 0 !important;
  transition: transform 0.18s ease, color 0.18s ease !important;
}

#chatyx-widget-root .chatyx-conversation-chevron svg {
  width: 16px !important;
  height: 16px !important;
  display: block !important;
}

#chatyx-widget-root .chatyx-conversation-item:hover .chatyx-conversation-chevron {
  transform: translateX(2px) !important;
  color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .chatyx-conversations-empty {
  text-align: center !important;
  color: #94a3b8 !important;
  font-size: 13px !important;
  padding: 32px 16px !important;
}

#chatyx-widget-root .chatyx-conversations-footer {
  padding: 12px 16px !important;
  padding-bottom: calc(12px + var(--chatyx-safe-area-bottom)) !important;
  background: #fff !important;
  border-top: 1px solid rgba(15, 23, 42, 0.07) !important;
  flex-shrink: 0 !important;
}

#chatyx-widget-root .chatyx-new-conversation-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  width: 100% !important;
  padding: 12px 16px !important;
  border: none !important;
  border-radius: 999px !important;
  background: var(--chatyx-primary) !important;
  color: var(--chatyx-primary-contrast, #fff) !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  font-family: 'Nunito', sans-serif !important;
  cursor: pointer !important;
  appearance: none !important;
  transition: background-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease !important;
  box-shadow: 0 6px 16px rgba(123, 64, 241, 0.28) !important;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--chatyx-primary) 30%, transparent) !important;
}

#chatyx-widget-root .chatyx-new-conversation-btn svg {
  width: 16px !important;
  height: 16px !important;
  color: currentColor !important;
}

#chatyx-widget-root .chatyx-new-conversation-btn:hover {
  background: var(--chatyx-primary-hover) !important;
  transform: translateY(-1px) !important;
}

#chatyx-widget-root .chatyx-new-conversation-btn:active {
  transform: translateY(0) scale(0.99) !important;
}

#chatyx-widget-root .chatyx-new-conversation-btn:focus-visible {
  outline: 2px solid #111827 !important;
  outline-offset: 2px !important;
}

/* ---- New-conversation confirmation modal ---- */
#chatyx-widget-root .chatyx-modal-overlay {
  position: absolute !important;
  inset: 0 !important;
  z-index: 1200 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 24px !important;
  background: rgba(15, 23, 42, 0.32) !important;
  backdrop-filter: blur(2px) !important;
  border-radius: 20px !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transition: opacity 0.22s ease, visibility 0s linear 0.22s !important;
}

#chatyx-widget-root .chatyx-modal-overlay.show {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transition: opacity 0.22s ease, visibility 0s linear 0s !important;
}

#chatyx-widget-root .chatyx-modal-card {
  width: 100% !important;
  max-width: 300px !important;
  background: #fff !important;
  border-radius: 18px !important;
  padding: 22px 20px !important;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.28) !important;
  text-align: center !important;
  transform: translateY(12px) scale(0.96) !important;
  transition: transform 0.26s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

#chatyx-widget-root .chatyx-modal-overlay.show .chatyx-modal-card {
  transform: translateY(0) scale(1) !important;
}

#chatyx-widget-root .chatyx-modal-title {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #1a1a1a !important;
  line-height: 1.35 !important;
  margin-bottom: 18px !important;
}

#chatyx-widget-root .chatyx-modal-actions {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

#chatyx-widget-root .chatyx-modal-btn {
  width: 100% !important;
  padding: 12px 16px !important;
  border: none !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  font-family: 'Nunito', sans-serif !important;
  cursor: pointer !important;
  appearance: none !important;
  transition: background-color 0.2s ease, transform 0.15s ease !important;
}

#chatyx-widget-root .chatyx-modal-btn:active {
  transform: scale(0.98) !important;
}

#chatyx-widget-root .chatyx-modal-btn-primary {
  background: var(--chatyx-primary) !important;
  color: var(--chatyx-primary-contrast, #fff) !important;
}

#chatyx-widget-root .chatyx-modal-btn-primary:hover {
  background: var(--chatyx-primary-hover) !important;
}

#chatyx-widget-root .chatyx-modal-btn-ghost {
  background: #f1f5f9 !important;
  color: #475569 !important;
}

#chatyx-widget-root .chatyx-modal-btn-ghost:hover {
  background: #e2e8f0 !important;
}

#chatyx-widget-root .chatyx-modal-btn:focus-visible {
  outline: 2px solid var(--chatyx-primary) !important;
  outline-offset: 2px !important;
}

@media (prefers-reduced-motion: reduce) {
  #chatyx-widget-root .chatyx-conversations-panel,
  #chatyx-widget-root .chatyx-modal-overlay,
  #chatyx-widget-root .chatyx-modal-card,
  #chatyx-widget-root .chat-refresh-button svg,
  #chatyx-widget-root .chat-theme-button svg {
    transition-duration: 0.01ms !important;
  }
  #chatyx-widget-root .chat-refresh-button:hover svg {
    transform: none !important;
  }
}

/* ============================================================ */
/* RESPONSIVE AMÉLIORÉ */
/* ============================================================ */

@media (min-width: 768px) and (max-width: 1024px) {
  #chatyx-widget-root .chat-container {
    width: min(420px, calc(var(--chatyx-viewport-width) - 40px)) !important;
    height: calc(var(--chatyx-viewport-height) - 120px) !important;
    max-height: 650px !important;
    bottom: 90px !important;
    right: 20px !important;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  #chatyx-widget-root .chat-container {
    width: calc(var(--chatyx-viewport-width) - 40px) !important;
    height: calc(var(--chatyx-viewport-height) - 120px) !important;
    max-height: 600px !important;
    bottom: 90px !important;
    right: 20px !important;
    left: 20px !important;
  }

  #chatyx-widget-root .message-row .bubble {
    max-width: 85% !important;
  }

  #chatyx-widget-root .chat-suggestions {
    margin-left: 10px !important;
    width: calc(100% - 20px) !important;
  }
}

@media (max-width: 480px) {
  #chatyx-widget-root .chat-container {
    width: var(--chatyx-viewport-width) !important;
    height: var(--chatyx-viewport-height) !important;
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 0 !important;
    max-width: none !important;
    max-height: none !important;
  }

  #chatyx-widget-root .chat-container.show {
    position: fixed !important;
  }

  #chatyx-widget-root .chatyx-conversations-panel,
  #chatyx-widget-root .chatyx-modal-overlay {
    border-radius: 0 !important;
  }

  #chatyx-widget-root.chat-open .chat-bubble {
    display: none !important;
  }

  #chatyx-widget-root .chat-bubble {
    bottom: calc(15px + var(--chatyx-safe-area-bottom)) !important;
    right: calc(15px + var(--chatyx-safe-area-right)) !important;
    width: 55px !important;
    height: 55px !important;
  }

  #chatyx-widget-root .chat-header-custom {
    padding: 14px 16px 10px 16px !important;
    padding-top: max(14px, calc(10px + var(--chatyx-safe-area-top))) !important;
  }

  #chatyx-widget-root .chat-header-buttons {
    top: max(12px, calc(8px + var(--chatyx-safe-area-top))) !important;
    right: max(14px, calc(10px + var(--chatyx-safe-area-right))) !important;
  }

  #chatyx-widget-root .message-row .bubble {
    max-width: 85% !important;
    font-size: 14px !important;
  }

  #chatyx-widget-root .chat-messages {
    padding: 10px !important;
  }

  #chatyx-widget-root .chat-suggestions {
    margin-left: 0 !important;
    width: 100% !important;
  }

  #chatyx-widget-root .chat-suggestions button {
    font-size: 14px !important;
    padding: 10px 16px !important;
  }

  #chatyx-widget-root .message-input {
    padding: 10px !important;
    padding-bottom: 5px !important;
  }

  #chatyx-widget-root .ai-disclaimer {
    padding-bottom: max(8px, calc(6px + var(--chatyx-safe-area-bottom))) !important;
  }

  #chatyx-widget-root .message-input input {
    font-size: 16px !important;
  }

  #chatyx-widget-root .chatbot-title {
    font-size: 16px !important;
  }

  #chatyx-widget-root .bot-status {
    font-size: 12px !important;
  }

  #chatyx-widget-root .message-row .bubble ul,
  #chatyx-widget-root .message-row .bubble ol {
    padding-left: 1.2em !important;
  }

  #chatyx-widget-root .message-row .bubble li {
    font-size: 14px !important;
    line-height: 1.4 !important;
  }

  #chatyx-widget-root .branding {
    padding-bottom: max(4px, calc(2px + var(--chatyx-safe-area-bottom))) !important;
  }

  #chatyx-widget-root .product-carousel-slide {
    padding: 12px !important;
  }

  #chatyx-widget-root .product-name {
    font-size: 14px !important;
  }

  #chatyx-widget-root .product-price {
    font-size: 16px !important;
  }

  #chatyx-widget-root .product-description {
    font-size: 12px !important;
    -webkit-line-clamp: 2 !important;
  }

  #chatyx-widget-root .carousel-nav {
    width: 32px !important;
    height: 32px !important;
    font-size: 16px !important;
  }

  #chatyx-widget-root .product-link {
    padding: 9px 16px !important;
    font-size: 12px !important;
  }
}

@media (max-width: 380px) {
  #chatyx-widget-root .header-bot-avatar {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }

  #chatyx-widget-root .chatbot-title {
    font-size: 15px !important;
  }

  #chatyx-widget-root .message-row .bubble {
    font-size: 13px !important;
    padding: 8px 10px !important;
  }

  #chatyx-widget-root .message-input button {
    width: 38px !important;
    height: 38px !important;
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  #chatyx-widget-root .chat-container {
    height: var(--chatyx-viewport-height) !important;
    max-height: var(--chatyx-viewport-height) !important;
  }

  #chatyx-widget-root.chat-open .chat-bubble {
    display: none !important;
  }

  #chatyx-widget-root .chat-header-custom {
    padding: 10px 15px 8px 15px !important;
    padding-top: max(10px, calc(6px + var(--chatyx-safe-area-top))) !important;
  }

  #chatyx-widget-root .header-bot-avatar {
    width: 35px !important;
    height: 35px !important;
    min-width: 35px !important;
  }

  #chatyx-widget-root .chatbot-title {
    font-size: 14px !important;
  }

  #chatyx-widget-root .bot-status {
    font-size: 11px !important;
  }

  #chatyx-widget-root .message-input {
    padding: 8px !important;
    padding-bottom: 4px !important;
  }

  #chatyx-widget-root .ai-disclaimer {
    font-size: 9px !important;
    padding-bottom: max(6px, calc(4px + var(--chatyx-safe-area-bottom))) !important;
  }

  #chatyx-widget-root .branding {
    padding: 2px !important;
    padding-bottom: max(2px, var(--chatyx-safe-area-bottom)) !important;
    font-size: 10px !important;
  }
}

/* ============================================================ */
/* DARK MODE                                                    */
/* ============================================================ */

#chatyx-widget-root.theme-dark .chat-container {
  --chatyx-message-bg: #1f2937 !important;
  --chatyx-message-border: rgba(148, 163, 184, 0.35) !important;
  background: #1f2937 !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5) !important;
}

#chatyx-widget-root.theme-dark .chat-messages {
  background: #111827 !important;
}

#chatyx-widget-root.theme-dark .chat-messages::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.2) !important;
}

#chatyx-widget-root.theme-dark .message-row.bot .bubble {
  background: #374151 !important;
  color: #e5e7eb !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

#chatyx-widget-root.theme-dark .message-row.user .bubble {
  background: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}

#chatyx-widget-root.theme-dark .message-row.bot .bubble.typing-bubble,
#chatyx-widget-root.theme-dark .message-row.user .bubble.typing-bubble {
  background: linear-gradient(140deg, rgba(55, 65, 81, 0.78), rgba(31, 41, 55, 0.86)) !important;
  border-color: rgba(196, 181, 253, 0.18) !important;
  box-shadow: 0 10px 26px rgba(2, 6, 23, 0.42) !important;
}

#chatyx-widget-root.theme-dark .message-row .bubble a {
  color: #a78bfa !important;
}

#chatyx-widget-root.theme-dark .message-meta .message-time {
  color: #9ca3af !important;
}

#chatyx-widget-root.theme-dark .message-meta .message-check {
  color: #6b7280 !important;
}

#chatyx-widget-root.theme-dark .chat-suggestions button {
  background: #374151 !important;
  color: #e5e7eb !important;
  border-color: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .chat-suggestions button:hover {
  background: var(--chatyx-primary) !important;
  color: #fff !important;
}

#chatyx-widget-root.theme-dark .message-input {
  background: #1f2937 !important;
  border-top-color: rgba(255, 255, 255, 0.08) !important;
}

#chatyx-widget-root.theme-dark .message-input input {
  background: #374151 !important;
  color: #e5e7eb !important;
  border-color: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .message-input input::placeholder {
  color: #9ca3af !important;
}

#chatyx-widget-root.theme-dark .ai-disclaimer {
  background: #1f2937 !important;
  color: #6b7280 !important;
}

#chatyx-widget-root.theme-dark .branding {
  background: #111827 !important;
  color: #6b7280 !important;
}

#chatyx-widget-root.theme-dark .branding strong {
  color: #d1d5db !important;
}

#chatyx-widget-root.theme-dark .consent-overlay {
  background: rgba(31, 41, 55, 0.98) !important;
}

#chatyx-widget-root.theme-dark .consent-title {
  color: #f3f4f6 !important;
}

#chatyx-widget-root.theme-dark .consent-text {
  color: #d1d5db !important;
}

#chatyx-widget-root.theme-dark .consent-text a {
  color: #a78bfa !important;
}

#chatyx-widget-root.theme-dark .consent-checkbox-label {
  color: #d1d5db !important;
}

#chatyx-widget-root.theme-dark .consent-decline {
  background: #374151 !important;
  color: #d1d5db !important;
  border-color: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .consent-decline:hover {
  background: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .consent-accept:disabled {
  background: #4b5563 !important;
}

/* ---- Conversations list + modal (dark) ---- */
#chatyx-widget-root.theme-dark .chatyx-conversations-panel {
  background: #111827 !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversations-header,
#chatyx-widget-root.theme-dark .chatyx-conversations-footer {
  background: #1f2937 !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversations-title {
  color: #f3f4f6 !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversation-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversation-avatar {
  background: #374151 !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversation-preview {
  color: #e5e7eb !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversation-time {
  color: #6b7280 !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversation-chevron {
  color: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .chatyx-conversations-empty {
  color: #6b7280 !important;
}

#chatyx-widget-root.theme-dark .chatyx-modal-card {
  background: #1f2937 !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55) !important;
}

#chatyx-widget-root.theme-dark .chatyx-modal-title {
  color: #f3f4f6 !important;
}

#chatyx-widget-root.theme-dark .chatyx-modal-btn-ghost {
  background: #374151 !important;
  color: #d1d5db !important;
}

#chatyx-widget-root.theme-dark .chatyx-modal-btn-ghost:hover {
  background: #4b5563 !important;
}

#chatyx-widget-root.theme-dark .product-carousel-track-container {
  background: #1f2937 !important;
}

#chatyx-widget-root.theme-dark .product-image-container {
  background: #374151 !important;
  border-color: rgba(255, 255, 255, 0.05) !important;
}

#chatyx-widget-root.theme-dark .product-name {
  color: #f3f4f6 !important;
}

#chatyx-widget-root.theme-dark .product-description {
  color: #9ca3af !important;
}

#chatyx-widget-root.theme-dark .carousel-nav {
  background: rgba(55, 65, 81, 0.95) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #e5e7eb !important;
}

#chatyx-widget-root.theme-dark .carousel-nav:hover {
  background: #374151 !important;
}

#chatyx-widget-root.theme-dark .carousel-indicators {
  background: #1f2937 !important;
  border-top-color: rgba(255, 255, 255, 0.05) !important;
}

#chatyx-widget-root.theme-dark .carousel-indicator {
  background: #4b5563 !important;
}

/* ===== Lead capture form ===== */

#chatyx-widget-root .bubble-form {
  width: 100% !important;
  max-width: 100% !important;
  padding: 12px !important;
}

#chatyx-widget-root .chatyx-lead-form__intro {
  margin-bottom: 8px !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
}

#chatyx-widget-root .chatyx-lead-form {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  margin-top: 4px !important;
  animation: chatyx-lead-form-in 220ms cubic-bezier(0.2, 0.8, 0.2, 1) !important;
}

#chatyx-widget-root .chatyx-lead-form__fieldset {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  min-width: 0 !important;
}

#chatyx-widget-root .chatyx-lead-form__sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

@keyframes chatyx-lead-form-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

#chatyx-widget-root .chatyx-lead-form__title {
  font-size: 15px !important;
  font-weight: 600 !important;
  margin-bottom: 2px !important;
}

#chatyx-widget-root .chatyx-lead-form__description {
  font-size: 13px !important;
  opacity: 0.8 !important;
}

#chatyx-widget-root .chatyx-lead-form__field {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  position: relative !important;
}

#chatyx-widget-root .chatyx-lead-form__label {
  font-size: 12px !important;
  font-weight: 600 !important;
  opacity: 0.85 !important;
  transition: color 0.15s ease, opacity 0.15s ease !important;
}

#chatyx-widget-root .chatyx-lead-form__field:focus-within .chatyx-lead-form__label {
  color: var(--chatyx-primary) !important;
  opacity: 1 !important;
}

#chatyx-widget-root .chatyx-lead-form__required {
  color: #d92d20 !important;
  margin-left: 3px !important;
  font-weight: 700 !important;
}

#chatyx-widget-root .chatyx-lead-form__field--shake {
  animation: chatyx-lead-shake 320ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both !important;
}

@keyframes chatyx-lead-shake {
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-4px); }
  40%, 60% { transform: translateX(4px); }
}

#chatyx-widget-root .chatyx-lead-form__input {
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 8px 10px !important;
  font-size: 14px !important;
  font-family: inherit !important;
  color: inherit !important;
  background: var(--chatyx-message-bg) !important;
  border: 1px solid var(--chatyx-border-color) !important;
  border-radius: 8px !important;
  outline: none !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
}

#chatyx-widget-root textarea.chatyx-lead-form__input {
  resize: vertical !important;
  min-height: 64px !important;
}

#chatyx-widget-root .chatyx-lead-form__input:focus {
  border-color: var(--chatyx-primary) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--chatyx-primary) 20%, transparent) !important;
}

#chatyx-widget-root .chatyx-lead-form__input:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

#chatyx-widget-root .chatyx-lead-form__input--error {
  border-color: #d92d20 !important;
}

#chatyx-widget-root .chatyx-lead-form__error {
  font-size: 12px !important;
  color: #d92d20 !important;
  min-height: 14px !important;
}

#chatyx-widget-root .chatyx-lead-form__honeypot {
  position: absolute !important;
  left: -9999px !important;
  width: 1px !important;
  height: 1px !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

#chatyx-widget-root .chatyx-lead-form__consent {
  display: flex !important;
  align-items: flex-start !important;
  gap: 8px !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"] {
  margin-top: 1px !important;
  flex: 0 0 auto !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  width: 18px !important;
  height: 18px !important;
  border: 1.5px solid var(--chatyx-border-color) !important;
  border-radius: 4px !important;
  background: var(--chatyx-message-bg) !important;
  cursor: pointer !important;
  position: relative !important;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"]:hover:not(:disabled) {
  border-color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"]:focus-visible {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--chatyx-primary) 25%, transparent) !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"]:checked {
  background: var(--chatyx-primary) !important;
  border-color: var(--chatyx-primary) !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"]:checked::after {
  content: '' !important;
  position: absolute !important;
  left: 5px !important;
  top: 1px !important;
  width: 5px !important;
  height: 10px !important;
  border: solid #fff !important;
  border-width: 0 2px 2px 0 !important;
  transform: rotate(45deg) !important;
}

#chatyx-widget-root .chatyx-lead-form__consent input[type="checkbox"]:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

#chatyx-widget-root .chatyx-lead-form__char-count {
  font-size: 11px !important;
  text-align: right !important;
  opacity: 0.55 !important;
  min-height: 14px !important;
  transition: color 0.15s ease, opacity 0.15s ease !important;
}

#chatyx-widget-root .chatyx-lead-form__char-count--warning {
  color: #d92d20 !important;
  opacity: 1 !important;
}

#chatyx-widget-root .chatyx-lead-form__actions {
  display: flex !important;
  justify-content: flex-end !important;
  margin-top: 4px !important;
}

#chatyx-widget-root .chatyx-lead-form__submit {
  appearance: none !important;
  border: 0 !important;
  cursor: pointer !important;
  padding: 8px 14px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: var(--chatyx-primary) !important;
  color: #fff !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  transition: background-color 0.15s ease, transform 0.05s ease, opacity 0.15s ease !important;
}

#chatyx-widget-root .chatyx-lead-form__submit-label {
  display: inline-block !important;
}

#chatyx-widget-root .chatyx-lead-form__check-icon {
  width: 16px !important;
  height: 16px !important;
  flex: 0 0 auto !important;
  display: inline-block !important;
}

#chatyx-widget-root .chatyx-lead-form__submit:hover:not(:disabled) {
  background: var(--chatyx-primary-hover) !important;
}

#chatyx-widget-root .chatyx-lead-form__submit:active:not(:disabled) {
  transform: translateY(1px) !important;
}

#chatyx-widget-root .chatyx-lead-form__submit:disabled {
  opacity: 0.55 !important;
  cursor: not-allowed !important;
}

#chatyx-widget-root .chatyx-lead-form__submit.is-loading {
  position: relative !important;
  color: transparent !important;
}

#chatyx-widget-root .chatyx-lead-form__submit.is-loading::after {
  content: '' !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  width: 14px !important;
  height: 14px !important;
  margin: -7px 0 0 -7px !important;
  border: 2px solid rgba(255, 255, 255, 0.5) !important;
  border-top-color: #fff !important;
  border-radius: 50% !important;
  animation: chatyx-lead-spin 0.7s linear infinite !important;
}

#chatyx-widget-root .chatyx-lead-form__submit.is-submitted {
  background: #2e7d32 !important;
  cursor: default !important;
  color: #fff !important;
  opacity: 1 !important;
}

#chatyx-widget-root .chatyx-lead-form__submit.is-submitted.is-loading {
  color: #fff !important;
}

#chatyx-widget-root .chatyx-lead-form__submit.is-submitted.is-loading::after {
  display: none !important;
}

#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__fieldset,
#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__consent,
#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__actions,
#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__status,
#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__description,
#chatyx-widget-root .chatyx-lead-form--submitted .chatyx-lead-form__title {
  display: none !important;
}

#chatyx-widget-root .chatyx-lead-form__success {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 14px 12px 12px !important;
  text-align: center !important;
  animation: chatyx-lead-success-in 280ms cubic-bezier(0.2, 0.8, 0.2, 1) both !important;
}

#chatyx-widget-root .chatyx-lead-form__success-icon {
  width: 44px !important;
  height: 44px !important;
  border-radius: 50% !important;
  background: rgba(46, 125, 50, 0.14) !important;
  color: #2e7d32 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 0 0 auto !important;
}

#chatyx-widget-root .chatyx-lead-form__success-icon .chatyx-lead-form__check-icon {
  width: 24px !important;
  height: 24px !important;
  color: currentColor !important;
}

#chatyx-widget-root .chatyx-lead-form__success-text {
  font-size: 13px !important;
  line-height: 1.45 !important;
  max-width: 280px !important;
}

@keyframes chatyx-lead-success-in {
  0% { opacity: 0; transform: scale(0.94); }
  60% { opacity: 1; }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes chatyx-lead-spin {
  to { transform: rotate(360deg); }
}

#chatyx-widget-root .chatyx-lead-form__status {
  font-size: 12px !important;
  min-height: 14px !important;
  text-align: right !important;
  opacity: 0.85 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__input {
  background: #2c2f36 !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
  color: #f3f4f6 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__error {
  color: #ff8a80 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__input--error {
  border-color: #ff8a80 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__consent input[type="checkbox"] {
  background: #2c2f36 !important;
  border-color: rgba(255, 255, 255, 0.22) !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__required {
  color: #ff8a80 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__char-count--warning {
  color: #ff8a80 !important;
}

#chatyx-widget-root.theme-dark .chatyx-lead-form__success-icon {
  background: rgba(46, 125, 50, 0.28) !important;
  color: #a5d6a7 !important;
}
